type SupportedLanguage = 'ja_JP' | 'en_US' | 'zh_TW' | 'zh_CH' | 'ko_KR' | 'fr_FR' | 'it_IT' | 'es_ES' | 'de_DE'

export const convertLanguage = (lang: string): SupportedLanguage => {
  switch (lang) {
    case 'ja':
    case 'ja-JP':
      return 'ja_JP'
    case 'en':
    case 'en-US':
      return 'en_US'
    case 'zh':
    case 'zh-CN':
      return 'zh_CH'
    case 'zh-TW':
      return 'zh_TW'
    case 'ko':
    case 'ko-KR':
      return 'ko_KR'
    case 'fr':
    case 'fr-FR':
      return 'fr_FR'
    case 'it':
    case 'it-IT':
      return 'it_IT'
    case 'es':
    case 'es-ES':
      return 'es_ES'
    case 'de':
    case 'de-DE':
      return 'de_DE'
    default:
      return 'ja_JP'
  }
}
